import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';

import {
  type AIFormRequest,
  type AIFormSuggestionsResponse,
} from 'hb-react/shared/components/AIFormWidget/types';
import { axiosWithSyntaxHandlers } from 'hb-react/shared/utils/axios';

export const useMutateSuggestion = () => {
  const url = useMemo(
    () =>
      // It's a poor man's way to check if we are in the backoffice but it's good enough for now since we're in alpha
      window.location.pathname.includes('backoffice')
        ? Routes.private_backoffice_networks_ai_form_suggestions_path
        : Routes.private_frontoffice_ai_form_suggestions_path,
    [],
  );

  return useMutation({
    mutationFn: (payload: AIFormRequest) =>
      axiosWithSyntaxHandlers
        .post<AIFormSuggestionsResponse>(url({ format: 'json' }), payload)
        .then(({ data }) => data),
  });
};
